export default __webpack_public_path__ + "static/Year1841_town-7c2540dca9f32962127e874b78ecd81a.jpg";